import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { fetchMe, login as apiLogin, logout as apiLogout, type IdpUser } from '@/api/idp'

export const useSessionStore = defineStore('session', () => {
  const user = ref<IdpUser | null>(null)
  const loaded = ref(false)

  const isAdmin = computed(() => {
    const e = user.value?.entry
    return e === 'admin' || e === 'both'
  })

  async function refresh() {
    try {
      user.value = await fetchMe()
    } catch {
      user.value = null
    } finally {
      loaded.value = true
    }
  }

  async function login(
    username: string,
    password: string,
    opts?: {
      loginType?: string
      schoolCode?: string
      captchaId?: string
      captchaAnswer?: string
    }
  ) {
    user.value = await apiLogin(username, password, opts)
    loaded.value = true
    return user.value
  }

  async function logout() {
    try {
      await apiLogout()
    } finally {
      user.value = null
    }
  }

  return { user, loaded, isAdmin, refresh, login, logout }
})
